__turbopack_context__.v({
  "soldOutBanner": "styles-module__vDc6dW__soldOutBanner",
});
